import dayjs from "dayjs";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { withAdminAuth } from "../../../components/GetAuth";
import PageHeader from "../../../components/PageHeader";
import { useWebsite } from "../../../../context/WebsiteContext";
import { useSiteBranding } from "../../../../hooks/useSiteBranding";
import styles from "../reports.module.css";
import useServerReport from "../components/useServerReport";
import ReportToolbar from "../components/ReportToolbar";
import ReportTable from "../components/ReportTable";

const formatDateTime = (value) => (value ? dayjs(value).format("DD/MM/YYYY hh:mmA") : "-");

const columns = [
    { key: "name", label: "Name", primary: true },
    { key: "user_type_name", label: "User Type", render: (row) => (row?.user_type_name ? <span className={`${styles.TypeTag}`}>{row.user_type_name}</span> : "-"), exportValue: (row) => row?.user_type_name },
    { key: "session_id", label: "Session Id" },
    { key: "created_at", label: "Login Time", render: (row) => formatDateTime(row?.created_at), exportValue: (row) => formatDateTime(row?.created_at) },
];

const UserTrackingReports = () => {
    const { websiteData } = useWebsite();
    useSiteBranding("User Tracking Reports", websiteData);

    const report = useServerReport("report/user-trackings", { type: "all" });

    return (<div className={`${styles.MainDiv}`}>
        <PageHeader title="User Tracking Reports" trail={[{ label: "Reports" }]} />

        <div className={`${styles.MainCard}`}>
            <ReportToolbar report={report} columns={columns} title="User Tracking Report" filename="user-tracking-report" searchPlaceholder="Search by name, type or session">
                <FormControl size="small" className={`${styles.SelectFilter}`}>
                    <InputLabel>User Type</InputLabel>
                    <Select value={report.filters.type} label="User Type" onChange={(e) => report.setFilter("type", e.target.value)}>
                        <MenuItem value={"all"}>All</MenuItem>
                        <MenuItem value={"driver"}>Driver</MenuItem>
                        <MenuItem value={"customer"}>Customer</MenuItem>
                    </Select>
                </FormControl>
            </ReportToolbar>
            <ReportTable report={report} columns={columns} />
        </div>
    </div>);
};

export default withAdminAuth(UserTrackingReports);
